{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} gesprekken geselecteerd",
    "AGENT_SELECT_LABEL": "Selecteer agent",
    "ASSIGN_CONFIRMATION_LABEL": "Weet u zeker dat u {conversationCount} {conversationLabel} wilt toewijzen aan",
    "UNASSIGN_CONFIRMATION_LABEL": "Weet u zeker dat u {conversationCount} {conversationLabel} wilt ontkoppelen?",
    "GO_BACK_LABEL": "Ga terug",
    "ASSIGN_LABEL": "Toewijzen",
    "YES": "Ja",
    "SEARCH_INPUT_PLACEHOLDER": "Zoeken",
    "ASSIGN_AGENT_TOOLTIP": "Agent toewijzen",
    "ASSIGN_TEAM_TOOLTIP": "Team toewijzen",
    "ASSIGN_SUCCESFUL": "Gesprekken succesvol toegewezen.",
    "ASSIGN_FAILED": "Toewijzen van gesprekken mislukt, probeer het opnieuw.",
    "RESOLVE_SUCCESFUL": "Gesprekken succesvol opgehaald.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Gesprekken die op deze pagina zichtbaar zijn, zijn alleen geselecteerd.",
    "AGENT_LIST_LOADING": "Agents worden geladen",
    "UPDATE": {
      "CHANGE_STATUS": "Status wijzigen",
      "SNOOZE_UNTIL": "Sluimeren",
      "UPDATE_SUCCESFUL": "Gespreksstatus succesvol bijgewerkt.",
      "UPDATE_FAILED": "Update van gesprekken mislukt, probeer het opnieuw."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Labels toewijzen",
      "NO_LABELS_FOUND": "Geen labels gevonden voor",
      "ASSIGN_SELECTED_LABELS": "Geselecteerde labels toewijzen",
      "ASSIGN_SUCCESFUL": "Labels met succes toegewezen.",
      "ASSIGN_FAILED": "Toewijzen van labels mislukt, probeer het opnieuw."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Selecteer team",
      "NONE": "Geen",
      "NO_TEAMS_AVAILABLE": "Er zijn nog geen teams toegevoegd aan dit account.",
      "ASSIGN_SELECTED_TEAMS": "Geselecteerde team toewijzen.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Toewijzen team mislukt, probeer het opnieuw."
    },
    "MERGE": {
      "TOOLTIP": "Gesprekken samenvoegen",
      "TITLE": "Gesprekken samenvoegen",
      "DESCRIPTION": "Selecteer een doelgesprek. Alle andere geselecteerde gesprekken worden hierin samengevoegd — hun berichten worden verplaatst naar het doelgesprek en de brongesprekken worden verwijderd.",
      "TARGET_LABEL": "Doelgesprek (blijft behouden)",
      "SOURCES_LABEL": "Brongesprekken (worden verwijderd)",
      "SELECT_TARGET": "Selecteer een gesprek als doel voor het samenvoegen",
      "WARNING": "Waarschuwing: deze actie kan niet ongedaan worden gemaakt. Berichten uit alle brongesprekken worden verplaatst naar het doelgesprek en de brongesprekken worden permanent verwijderd.",
      "SUBMIT": "Gesprekken samenvoegen",
      "CANCEL": "Annuleren",
      "SUCCESS_MESSAGE": "Gesprekken succesvol samengevoegd",
      "ERROR_MESSAGE": "Kan de gesprekken niet samenvoegen. Probeer het opnieuw.",
      "CONFIRM": {
        "TITLE": "Samenvoegen bevestigen",
        "DESCRIPTION": "Weet u zeker dat u {sourceCount} gesprekken wilt samenvoegen in #{targetId}? Deze actie kan niet ongedaan worden gemaakt.",
        "YES": "Ja, samenvoegen",
        "CANCEL": "Annuleren"
      }
    }
  }
}
